import { JobService } from './../../services/job-details/job.service';
import { ProfileSettingsService } from './../../services/shared/profile-settings/profile-settings.service';
import { copyTextToClipboard, jsonDeepParse, prepareFieldConfigFlagsNew, preparePortalV2 } from 'src/app/functions/shared-functions';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { environment } from 'src/environments/environment';
import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { JobsService } from 'src/app/services/jobs/jobs.service';
import { MatDialog } from '@angular/material/dialog';
import { SocialMediaShareComponent } from '../shared/social-media-share/social-media-share.component';
import { ResumeReferralDetailsComponent } from '../resume-referral/resume-referral-details/resume-referral-details.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterDetails } from 'src/app/classes/job-filter/filter';
import { LabelType, Options } from 'ng5-slider';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SessionService } from 'src/app/services/session/session.service';
import { getIP } from '../jobseeker-registration/services/registration/jobseeker-registration.service';
import { ConfirmationComponent } from '../shared/confirmation/confirmation.component';
import { cloneArray, jsonParse } from 'src/app/app.component';
import { getSessionStorageItem } from 'src/app/controls/functions/functions';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { MatDrawer } from '@angular/material/sidenav';
import { LoginComponentV2 } from '../login-v2/login.component';
import { arrayToObject, storage_url } from 'src/app/controls/functions/shared-functions';
import { AppliedFiltersCountComponent } from './applied-filters-count/applied-filters-count.component';
import { Session } from 'src/app/classes/session/session';


export const skip = 0;
export const take = 50;
@Component({
  selector: 'app-ijp',
  templateUrl: './ijp.component.html',
  styleUrls: ['./ijp.component.scss',
    './ijp.v2.component.scss'],
  providers: [JobsService, JobService]
})
export class IjpComponent implements OnInit {
  masters: any = {}
  comment: any = [];
  filter_details: any = {};
  jobs = [];
  fetch_jobs = 0;
  @ViewChild('jobs_section') jobs_section: ElementRef;
  emp_job_apply;
  refer_a_friend;
  share_flag;
  // value: number = 0;
  // highValue: number = 10;

  job_details_display;
  like_flags;
  comment_flags;
  last_scroll_index;
  skip;
  take = 40;
  take_1 = 50;
  total_count;
  user_id;
  ip_details;
  resId = 0;
  job_details: any = {}
  relevant_jobs = []

  filter_form: UntypedFormGroup = new UntypedFormGroup({
    "search": new UntypedFormControl(''),
    "resId": new UntypedFormControl(''),
    "sellerShortCode": new UntypedFormControl(environment.SHORTCODE),
    "expFrom": new UntypedFormControl(0),
    "expTo": new UntypedFormControl(0),
    "jobType": new UntypedFormControl(null),
    "location": new UntypedFormControl([]),
    "currency": new UntypedFormControl(2),
    "minSalary": new UntypedFormControl(0),
    "maxSalary": new UntypedFormControl(0),
    "scale": new UntypedFormControl(4),
    "startPage": new UntypedFormControl(1),
    "limit": new UntypedFormControl(10),
    "myJobs": new UntypedFormControl(0),
    clients: new UntypedFormControl(null),
    sortBy: new UntypedFormControl(1),
    salaryRange: new UntypedFormControl(null),
    locationId: new UntypedFormControl(null),
    jobTypeId: new UntypedFormControl(null),
    industryId: new UntypedFormControl(null),
    industries: new UntypedFormControl(null),
  });
  default_settings: any = {};
  @ViewChild('sideNav2', { static: false }) sidebar: MatDrawer;
  default_banner_url = 'assets/jobs/wehiring.svg';

  @ViewChild(CdkVirtualScrollViewport) viewport: CdkVirtualScrollViewport;
  enable_lock = 0;
  portal_details: any;
  view_type = 2;
  storage_url = storage_url;
  prepared_filter: any;
  field_config_access: any = {};
  careerPortalConfig: any = {};
  sortBy = 1;
  list = [{
    id: 1,
    title: 'Freshness'
  },
  {
    id: 2,
    title: 'Relevance'
  },
  {
    id: 3,
    title: 'Favorite'
  }]
  value: number = 0;
  highValue: number = 0;

  salaryValue: number = 0;
  salaryHighValue: number = 90;
  options: Options = {
    floor: 0,
    ceil: 80,
    step: 1,
    showTicks: true,
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        default:
          return value + ' yrs';
      }
    },
    stepsArray: [
      { value: 0 },
      { value: 1 },
      { value: 2 },
      { value: 3 },
      { value: 4 },
      { value: 5 },
      { value: 6 },
      { value: 7 },
      { value: 8 },
      { value: 9 },
      { value: 10 },
      { value: 15 },
      { value: 20 },
      { value: 25 },
      { value: 30 },
      { value: 40 },
      { value: 60 },
      { value: 70 },
      { value: 80 },
    ]
  };
  options_salary: Options = {
    floor: 0,
    ceil: 80,
    step: 1,
    showTicks: true,
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        default:
          return value + ' Lakhs';
      }
    },
    stepsArray: [
      { value: 0 },
      { value: 1 },
      { value: 2 },
      { value: 3 },
      { value: 4 },
      { value: 5 },
      { value: 6 },
      { value: 7 },
      { value: 8 },
      { value: 9 },
      { value: 10 },
      { value: 15 },
      { value: 20 },
      { value: 25 },
      { value: 30 },
      { value: 40 },
      { value: 60 },
      { value: 70 },
      { value: 80 },
      { value: 90 }

    ]
  };

  salary_range_list = [{
    id: 1,
    title: '0-3 Lakhs'
  },
  {
    id: 2,
    title: '3-5 Lakhs'
  },
  {
    id: 3,
    title: '5-10Lakhs'
  },
  {
    id: 4,
    title: '10-15 Lakhs'
  },
  {
    id: 5,
    title: '15-25 Lakhs'
  },
  {
    id: 6,
    title: '25-50 Lakhs'
  },
  {
    id: 7,
    title: '50-75 Lakhs'
  },
  {
    id: 8,
    title: '75-100 Lakhs'
  },
  {
    id: 9,
    title: '100+ Lakhs'
  },]
  applied_filters = [];
  page_rendered: boolean = false;
  limit_list = [{ title: 10, code: 10 }, { title: 20, code: 20 }, { title: 40, code: 40 }, { title: 80, code: 80 }]
  start_page = 1;
  limit = 10;
  base_url = 'https://storage.googleapis.com/ezeone/icanrefer/'
  customStyle: any;
  timer: number = -1;
  session: any = new Session();
  token: any;
  constructor(
    private jobs_service: JobsService,
    private job_srv: JobService,
    public dialog: MatDialog,
    public activated_route: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private change_detect: ChangeDetectorRef,
    private session_service: SessionService,
    private notification_srv: NotificationService,
    private router: Router,
    private profile_settings_srv: ProfileSettingsService

  ) {

  }
  comment_form = this.formBuilder.group({
    comment: '',
    req_id: '',
    status_flag: 1
  })


  ngOnInit() {
    console.log(sessionStorage.getItem('system_defaults'))
    try {
      this.resId = JSON.parse(sessionStorage.getItem('resId')) || 0;
      this.filter_form.controls.resId.patchValue(this.resId)
    }
    catch (err) {

    }


    try {
      let mas = sessionStorage.getItem('job_search_masters');
      if (mas) {
        this.masters = jsonParse(mas) || {}
      }

    }
    catch (err) {
      console.log(err)
    }

    try {
      let portal_details = jsonParse(localStorage.getItem('portal_details'));
      if (portal_details && portal_details.banners && portal_details.banners.length) {
        this.default_banner_url = 'https://storage.googleapis.com/ezeone/icanrefer/' + portal_details.banners[0].cdnPath;
        console.log(this.default_banner_url)
        this.portal_details = portal_details
        if (this.portal_details && this.portal_details.portalFilterSettings && this.portal_details.portalFilterSettings.length) {
          this.prepared_filter = arrayToObject(this.portal_details.portalFilterSettings, 'filterCode')
          console.log(this.prepared_filter)
        }
      }
      else {
        this.default_banner_url = 'assets/jobs/wehiring.svg'
      }
    }
    catch (err) {
      console.log(err)
    }

    this.skip = skip;
    this.take = take;
    this.ip_details = getIP() || {}
    this.loadMasters(this.ip_details.country)
    this.user_id = 0;
    this.session_service.session.subscribe(res => {
      this.session = res;
      if (this.session && this.session.userId) {
        this.user_id = this.session.userId;
      }
      if (this.session && this.session.token) {
        this.token = this.session.token;
      } else {
        this.token = null;
      }
      if (!this.session) {
        this.user_id = 0;
      }
    });

  }
  closeAnnoucement() {
    this.timer = 0;
  }

  loadMasters(country) {
    let code = localStorage.getItem('sellerShortCode');
    if (code && code != '') {
      this.JobsList();
      this.jobs_service.getJobSearchMaster({
        sellerShortCode: environment.SHORTCODE,
        countryCode: country
      }).subscribe(res => {
        if (res && res['data']) {
          console.log(res['data']);
          sessionStorage.setItem('job_search_masters', JSON.stringify(res['data']))
          this.masters = res['data'];
        }
      })
      this.profile_settings_srv.loadDefaultSettings().subscribe(res => {
        if (res && res['data']) {
          if (res && res['data'] && res['data'].companySettingsJson) {
            let portal_details = jsonDeepParse(res['data'].companySettingsJson);

            this.portal_details = portal_details;
            if (this.portal_details) {
              this.view_type = this.portal_details.portalDesignPatternSettings || 2
            }

            this.mainViewport();
            if (this.portal_details && this.portal_details.portalFilterSettings && this.portal_details.portalFilterSettings.length) {
              this.prepared_filter = arrayToObject(this.portal_details.portalFilterSettings, 'filterCode')
              console.log(this.prepared_filter)
            }
            preparePortalV2(this.portal_details);
            if (portal_details && portal_details.banners && portal_details.banners.length) {
              this.default_banner_url = 'https://storage.googleapis.com/ezeone/icanrefer/' + portal_details.banners[0].cdnPath;
              console.log(this.default_banner_url)
            }
            else {
              this.default_banner_url = 'assets/jobs/wehiring.svg'
            }
            localStorage.setItem('portal_details', JSON.stringify(this.portal_details));
          }
          if (res['data'].careerPortalConfig) {
            let portal_details = jsonDeepParse(res['data'].careerPortalConfig.portalSettings);
            this.careerPortalConfig = portal_details;

            if (portal_details && portal_details.banners && portal_details.banners.length) {
              this.default_banner_url = 'https://storage.googleapis.com/ezeone/icanrefer/' + portal_details.banners[0].cdnPath;
              console.log(this.default_banner_url)
            }
            else {
              this.default_banner_url = 'assets/jobs/wehiring.svg'
            }
            if (this.careerPortalConfig && this.careerPortalConfig.portalAnnouncementStyle) {
              this.careerPortalConfig.pportalAnnouncementStyle = this.prepareStyle(this.careerPortalConfig.portalAnnouncementStyle)
              this.customStyle = this.prepareStyle(this.careerPortalConfig.portalAnnouncementStyle);
            }
            if (this.careerPortalConfig && this.careerPortalConfig.autoDisappear) {
              setTimeout(() => {
                this.timer = 0;
              }, this.careerPortalConfig.autoDisappear)
            }
            if (this.careerPortalConfig && this.careerPortalConfig.portalAnnouncementAfterLogin) {
              this.session = this.session_service.getSessionData()
              this.careerPortalConfig.portalAnnouncementAfterLogin = this.careerPortalConfig.portalAnnouncementAfterLogin.replace("\[username\]", this.session && this.session.userName || '')
            }
          }
          if (res['data'].fieldConfigFlags) {
            this.field_config_access = prepareFieldConfigFlagsNew(res['data'].fieldConfigFlags, null, null, "CAREERS_");
            console.log(this.field_config_access)
          }
        }
      })
    }

    else {
      this.profile_settings_srv.loadDefaultSettings().subscribe(res => {
        if (res && res['data']) {
          if (res && res['data'] && res['data'].companySettingsJson) {
            let portal_details = jsonDeepParse(res['data'].companySettingsJson);
            this.portal_details = portal_details;
            if (this.portal_details) {
              this.view_type = this.portal_details.portalDesignPatternSettings || 2
            }
            this.mainViewport()
            if (this.portal_details && this.portal_details.portalFilterSettings && this.portal_details.portalFilterSettings.length) {
              this.prepared_filter = arrayToObject(this.portal_details.portalFilterSettings, 'filterCode')
              console.log(this.prepared_filter)
            }
            if (portal_details && portal_details.banners && portal_details.banners.length) {
              this.default_banner_url = 'https://storage.googleapis.com/ezeone/icanrefer/' + portal_details.banners[0].cdnPath;
              console.log(this.default_banner_url)
            }
            else {
              this.default_banner_url = 'assets/jobs/wehiring.svg'
            }
            localStorage.setItem('portal_details', JSON.stringify(this.portal_details));
          }
          if (res['data'].careerPortalConfig) {
            let portal_details = jsonDeepParse(res['data'].careerPortalConfig.portalSettings);
            this.careerPortalConfig = portal_details;
            if (portal_details && portal_details.banners && portal_details.banners.length) {
              this.default_banner_url = 'https://storage.googleapis.com/ezeone/icanrefer/' + portal_details.banners[0].cdnPath;
              console.log(this.default_banner_url)
            }
            else {
              this.default_banner_url = 'assets/jobs/wehiring.svg'
            }
            if (this.careerPortalConfig && this.careerPortalConfig.portalAnnouncementStyle) {
              this.careerPortalConfig.pportalAnnouncementStyle = this.prepareStyle(this.careerPortalConfig.portalAnnouncementStyle)
              this.customStyle = this.prepareStyle(this.careerPortalConfig.portalAnnouncementStyle);
            }
            if (this.careerPortalConfig && this.careerPortalConfig.autoDisappear) {
              setTimeout(() => {
                this.timer = 0;
              }, this.careerPortalConfig.autoDisappear)
            }
            if (this.careerPortalConfig && this.careerPortalConfig.portalAnnouncementAfterLogin) {
              this.session = this.session_service.getSessionData()
              this.careerPortalConfig.portalAnnouncementAfterLogin = this.careerPortalConfig.portalAnnouncementAfterLogin.replace("\[username\]", this.session && this.session.userName || '')
            }
          }
          if (res['data'].fieldConfigFlags) {
            this.field_config_access = prepareFieldConfigFlagsNew(res['data'].fieldConfigFlags, null, null, "CAREERS_");
            console.log(this.field_config_access)
          }
          localStorage.setItem('sellerShortCode', res['data'].sellerShortCode)
          this.JobsList();
          this.jobs_service.getJobSearchMaster({
            sellerShortCode: environment.SHORTCODE,
            countryCode: country
          }).subscribe(res => {
            if (res && res['data']) {
              sessionStorage.setItem('job_search_masters', JSON.stringify(res['data']))
              console.log(res['data']);
              this.masters = res['data'];
            }
          })
        }


      })
    }

    console.log(this.portal_details)
  }
  prepareStyle(a) {
    console.log(a)
    let style = {};
    if (a) {
      a.split(',').forEach(item => { if (item.split(':').length == 2) { style[item.split(':')[0]] = item.split(':')[1] } })
    }
    return style;
  }

  mainViewport() {
    console.log('s')
    setTimeout(() => {
      try {

        let top = document.getElementById('job-explain-content').offsetTop - 50
        // let top = 0;
        console.log(top)
        window.scrollTo(
          {
            top: top,
            behavior: 'smooth'
          }
        )
      }
      catch (err) {
        console.log(err)
      }
    }, 200)
    // document.getElementById('job-explain-content').scrollIntoView({ behavior: 'smooth' })

  }
  openNewTabs(job) {
    this.router.navigate(['job', job.productCode]);
  }
  applyJob(ev) {
    if (this.view_type == 1 || !this.view_type) {
      let resId = parseInt(getSessionStorageItem('resId'));
      this.resId = resId
      // let params: any = Object.assign({}, this.activated_route.snapshot.queryParams);
      //   params['job'] = ev.productCode;
      let params = Object.assign(ev, this.activated_route.snapshot.queryParams)
      if (ev && !ev.applied) {
        if (!resId) {
          const dialog = this.dialog.open(LoginComponentV2, {
            width: '50%',
            disableClose: true,
            panelClass: "TM-Dialog",
            data: params

          });
          dialog.afterClosed().subscribe(result => {
            if (result && result.status) {
              resId = parseInt(getSessionStorageItem('resId'));
              this.applyJob(ev);
            }
          });
        }
        if (resId && resId > 0) {

          if (ev && ev.assessment) {
            try {
              ev.assessment = JSON.parse(ev.assessment)
            }
            catch (err) {

            }
          }
          if (ev && ev.assessment && ev.assessment.length) {
            ev.assessment.forEach(a => {
              a.options = jsonParse(a.options)
            })
            this.dialog.open(ConfirmationComponent, {
              width: '60%',
              height: 'auto',
              panelClass: "TM-Dialog",

              data: {
                title: 'Submit Assessment',
                assessment: ev.assessment,
                positive_button: 'BTN.apply',
                negative_button: 'BTN.cancel'
              }
            }).afterClosed().subscribe(res => {
              if (res) {

                let request = {}
                request['assessment'] = res.assessment;
                request['resId'] = this.resId;
                request['productCode'] = ev.productCode
                this.jobs_service.applyForJob(request).subscribe(res => {
                  if (res && res['status']) {
                    ev.applied = 1;
                    this.notification_srv.success(res['message'], 'Close', 10000);
                    if (this.jobs && this.jobs.length) {
                      let index = this.jobs.findIndex(data => data.productCode == request['productCode']);
                      if (index > -1) {
                        this.jobs[index].applied = 1;
                      }
                    }
                    this.jobs = cloneArray(this.jobs)
                    console.log(this.jobs)
                  }
                  else {
                    ev.applied = 0;
                    this.notification_srv.error(res['message'], 'Close', 10000);
                  }
                })
              }
            })
          }
          else {
            this.dialog.open(ConfirmationComponent, {
              width: '30%',
              height: 'auto',
              panelClass: "TM-Dialog",

              data: {
                title: 'CONFIRMATION.confirmation',
                message: 'Are you sure to apply for the position',
                message1: ev.productName + ' ',
                positive_button: 'BTN.apply',
                negative_button: 'BTN.cancel'
              }
            }).afterClosed().subscribe(res => {
              if (res) {
                let request = {}
                request['assessment'] = [];
                request['resId'] = this.resId;
                request['productCode'] = ev.productCode
                this.jobs_service.applyForJob(request).subscribe(res => {
                  if (res && res['status']) {
                    ev.applied = 1;
                    this.notification_srv.success(res['message'], 'Close', 10000);
                    if (this.jobs && this.jobs.length) {
                      let index = this.jobs.findIndex(data => data.productCode == request['productCode']);
                      if (index > -1) {
                        this.jobs[index].applied = 1;
                      }
                    }
                    this.jobs = cloneArray(this.jobs)
                  }
                  else {
                    ev.applied = 0;
                    this.notification_srv.error(res['message'], 'Close', 10000);
                  }
                })
              }
            })
          }
        }
      }
      else {
        this.notification_srv.error('You have already applied for this Job', 'Close', 5000)
      }
    }
    else {
      this.router.navigate(['job', ev.productCode]);
    }

  }

  applyJobV2(ev) {
    let resId = parseInt(getSessionStorageItem('resId'));
    if (!this.portal_details || this.portal_details && (!this.portal_details.portalDesignPatternSettings || this.portal_details.portalDesignPatternSettings == 1 ||
      this.portal_details.portalDesignPatternSettings == 2)) {
      if (!resId) {
        let route_info = this.router.url;
        let params: any = Object.assign({}, this.activated_route.snapshot.queryParams);
        params['job'] = ev.productCode;
        const dialog = this.dialog.open(LoginComponentV2, {
          width: '500px',
          disableClose: true,
          panelClass: "TM-Dialog",
          data: {
            jobDetails: ev,
            params: Object.assign({}, this.activated_route.snapshot.queryParams),
            queryParams: params,
          }
        });
        dialog.afterClosed().subscribe(result => {
          if (result && result.status) {
            this.router.navigate([route_info]);
            this.applyJob(ev);
          }
        });
      }
      if (resId && resId > 0) {

        if (ev && ev.assessment) {
          try {
            ev.assessment = JSON.parse(ev.assessment)
          }
          catch (err) {

          }
        }
        if (ev && ev.assessment && ev.assessment.length) {
          ev.assessment.forEach(a => {
            a.options = jsonParse(a.options)
          })
          this.dialog.open(ConfirmationComponent, {
            width: '60%',
            height: 'auto',
            panelClass: "TM-Dialog",

            data: {
              title: 'Submit Assessment',
              assessment: ev.assessment,
              positive_button: 'BTN.apply',
              negative_button: 'BTN.cancel'
            }
          }).afterClosed().subscribe(res => {
            if (res) {

              let request = Object.assign({}, this.activated_route.snapshot.queryParams) || {}
              request['assessment'] = res.assessment;
              request['resId'] = resId;
              request['productCode'] = ev.productCode
              this.jobs_service.applyForJob(request).subscribe(res => {
                if (res && res['status']) {
                  ev.applied = 1;
                  this.notification_srv.success(res['message'], 'Close', 10000);
                }
                else {
                  ev.applied = 0;
                  this.notification_srv.error(res['message'], 'Close', 10000);
                }
              })
            }
          })
        }
        else {
          this.dialog.open(ConfirmationComponent, {
            width: '30%',
            height: 'auto',
            panelClass: "TM-Dialog",

            data: {
              title: 'CONFIRMATION.confirmation',
              message: 'Are you sure to apply for the position',
              message1: ev.productName + ' ',
              positive_button: 'BTN.apply',
              negative_button: 'BTN.cancel'
            }
          }).afterClosed().subscribe(res => {
            if (res) {
              let request = Object.assign({}, this.activated_route.snapshot.queryParams)
              request['assessment'] = [];
              request['resId'] = resId;
              request['productCode'] = ev.productCode
              this.jobs_service.applyForJob(request).subscribe(res => {
                if (res && res['status']) {
                  ev.applied = 1;
                  this.notification_srv.success(res['message'], 'Close', 10000);
                }
                else {
                  ev.applied = 0;
                  this.notification_srv.error(res['message'], 'Close', 10000);
                }
              })
            }
          })
        }
      }
    }
    else {
      if (this.field_config_access && this.field_config_access['CAREERS_showRegistrationOnDetailsPage']) {
        if (!resId) {
          return;
        }
        if (resId && resId > 0) {

          if (ev && ev.assessment) {
            try {
              ev.assessment = JSON.parse(ev.assessment)
            }
            catch (err) {

            }
          }
          if (ev && ev.assessment && ev.assessment.length) {
            ev.assessment.forEach(a => {
              a.options = jsonParse(a.options)
            })
            this.dialog.open(ConfirmationComponent, {
              width: '60%',
              height: 'auto',
              panelClass: "TM-Dialog",

              data: {
                title: 'Submit Assessment',
                assessment: ev.assessment,
                positive_button: 'BTN.apply',
                negative_button: 'BTN.cancel'
              }
            }).afterClosed().subscribe(res => {
              if (res) {

                let request = Object.assign({}, this.activated_route.snapshot.queryParams) || {}
                request['assessment'] = res.assessment;
                request['resId'] = resId;
                request['productCode'] = ev.productCode
                this.jobs_service.applyForJob(request).subscribe(res => {
                  if (res && res['status']) {
                    ev.applied = 1;
                    this.notification_srv.success(res['message'], 'Close', 10000);
                  }
                  else {
                    ev.applied = 0;
                    this.notification_srv.error(res['message'], 'Close', 10000);
                  }
                })
              }
            })
          }
          else {
            this.dialog.open(ConfirmationComponent, {
              width: '30%',
              height: 'auto',
              panelClass: "TM-Dialog",

              data: {
                title: 'CONFIRMATION.confirmation',
                message: 'Are you sure to apply for the position',
                message1: ev.productName + ' ',
                positive_button: 'BTN.apply',
                negative_button: 'BTN.cancel'
              }
            }).afterClosed().subscribe(res => {
              if (res) {
                let request = Object.assign({}, this.activated_route.snapshot.queryParams)
                request['assessment'] = [];
                request['resId'] = resId;
                request['productCode'] = ev.productCode
                this.jobs_service.applyForJob(request).subscribe(res => {
                  if (res && res['status']) {
                    ev.applied = 1;
                    this.notification_srv.success(res['message'], 'Close', 10000);
                  }
                  else {
                    ev.applied = 0;
                    this.notification_srv.error(res['message'], 'Close', 10000);
                  }
                })
              }
            })
          }
        }
      }
      else {
        if (!resId) {
          let route_info = this.router.url;
          let params: any = Object.assign({}, this.activated_route.snapshot.queryParams);
          params['job'] = ev.productCode;
          const dialog = this.dialog.open(LoginComponentV2, {
            width: '500px',
            disableClose: true,
            panelClass: "TM-Dialog",
            data: {
              jobDetails: ev,
              params: Object.assign({}, this.activated_route.snapshot.queryParams),
              queryParams: params,
            }
          });
          dialog.afterClosed().subscribe(result => {
            if (result && result.status) {
              this.router.navigate([route_info]);
              this.applyJob(ev);
            }
          });
        }
        if (resId && resId > 0) {

          if (ev && ev.assessment) {
            try {
              ev.assessment = JSON.parse(ev.assessment)
            }
            catch (err) {

            }
          }
          if (ev && ev.assessment && ev.assessment.length) {
            ev.assessment.forEach(a => {
              a.options = jsonParse(a.options)
            })
            this.dialog.open(ConfirmationComponent, {
              width: '60%',
              height: 'auto',
              panelClass: "TM-Dialog",

              data: {
                title: 'Submit Assessment',
                assessment: ev.assessment,
                positive_button: 'BTN.apply',
                negative_button: 'BTN.cancel'
              }
            }).afterClosed().subscribe(res => {
              if (res) {

                let request = Object.assign({}, this.activated_route.snapshot.queryParams) || {}
                request['assessment'] = res.assessment;
                request['resId'] = resId;
                request['productCode'] = ev.productCode
                this.jobs_service.applyForJob(request).subscribe(res => {
                  if (res && res['status']) {
                    ev.applied = 1;
                    this.notification_srv.success(res['message'], 'Close', 10000);
                  }
                  else {
                    ev.applied = 0;
                    this.notification_srv.error(res['message'], 'Close', 10000);
                  }
                })
              }
            })
          }
          else {
            this.dialog.open(ConfirmationComponent, {
              width: '30%',
              height: 'auto',
              panelClass: "TM-Dialog",

              data: {
                title: 'CONFIRMATION.confirmation',
                message: 'Are you sure to apply for the position',
                message1: ev.productName + ' ',
                positive_button: 'BTN.apply',
                negative_button: 'BTN.cancel'
              }
            }).afterClosed().subscribe(res => {
              if (res) {
                let request = Object.assign({}, this.activated_route.snapshot.queryParams)
                request['assessment'] = [];
                request['resId'] = resId;
                request['productCode'] = ev.productCode
                this.jobs_service.applyForJob(request).subscribe(res => {
                  if (res && res['status']) {
                    ev.applied = 1;
                    this.notification_srv.success(res['message'], 'Close', 10000);
                  }
                  else {
                    ev.applied = 0;
                    this.notification_srv.error(res['message'], 'Close', 10000);
                  }
                })
              }
            })
          }
        }
      }


    }



  }


  openFilters() {
    //
    this.dialog.open(AppliedFiltersCountComponent, {
      width: '50%',
      panelClass: 'TM-Dialog',
      data: this.applied_filters
    }).afterClosed().subscribe(res => {
      if (res && res.reset) {
        this.filter_form.reset();
        this.filter_form.controls.sortBy.patchValue(1)
        this.filter_form.controls.currency.patchValue(2)
        this.filter_form.controls.scale.patchValue(4);
        this.value = 0;
        this.highValue = 0;
        this.JobsList()
      }
    })
  }

  saveJob(details) {
    if (details) {
      details['saved'] = !details['saved'];
    }
  }
  getPortalListFilter() {
    this.JobsList();
  }

  filter(event, flag) {
    this.skip = 0;
    this.take = 50;
    if (flag == 1 && event.keyCode == 13) {
      console.log(event)
      this.JobsList();
    }
    if (flag == 2) {
    }
  }
  reset() {
    this.filter_form.reset()
    this.filter_form.controls.sortBy.patchValue(1)
    this.filter_form.controls.currency.patchValue(2)
    this.filter_form.controls.scale.patchValue(4);
    this.JobsList()
  }

  prepareFilterList(obj) {
    let filter_list = [];
    if (obj) {
      if (obj['expFrom'] || obj['expTo']) {
        obj['experience'] = (obj['expFrom'] || 0) + '-' + obj['expTo'] + 'yrs'
      }
      Object.keys(obj).forEach(k => {
        if (k == 'search') {
          if (obj[k]) {
            filter_list.push(obj[k])
          }
        }
        else if (k == 'experience') {
          filter_list.push(obj[k])
        }
        else if (k == 'jobType') {
          if (obj[k] && obj[k].length && this.masters.jobTypeList && this.masters.jobTypeList.length) {
            obj[k].forEach(dataId => {
              let index = this.masters.jobTypeList.findIndex(master => master.id == dataId);
              if (index > -1) {
                filter_list.push(this.masters.jobTypeList[index].title)
              }
            })
          }
        }
        else if (k == 'location') {
          if (obj[k] && obj[k].length && this.masters.locationList && this.masters.locationList.length) {
            obj[k].forEach(dataId => {
              let index = this.masters.locationList.findIndex(master => master.id == dataId);
              if (index > -1) {
                filter_list.push(this.masters.locationList[index].title)
              }
            })
          }
        }
        else if (k == 'salaryRange') {
          if (obj[k] && obj[k].length && (this.masters.salaryRangeList && this.masters.salaryRangeList.length || this.salary_range_list)) {
            obj[k].forEach(dataId => {
              if (!this.masters.salaryRangeList || !this.masters.salaryRangeList.length) {
                this.masters.salaryRangeList = this.salary_range_list;
              }
              let index = this.masters.salaryRangeList.findIndex(master => master.id == dataId);
              if (index > -1) {
                filter_list.push(this.masters.salaryRangeList[index].title)
              }
            })
          }
        }
        else if (k == 'clients') {
          if (obj[k] && obj[k].length && this.masters.clientList && this.masters.clientList.length) {
            obj[k].forEach(dataId => {
              let index = this.masters.clientList.findIndex(master => master.id == dataId);
              if (index > -1) {
                filter_list.push(this.masters.clientList[index].title)
              }
            })
          }
        }
        else if (k == 'sortBy') {
          if (obj[k] && obj[k].length && this.list && this.list.length) {
            obj[k].forEach(dataId => {
              let index = this.list.findIndex(master => master.id == dataId);
              if (index > -1) {
                filter_list.push(this.list[index].title)
              }
            })
          }
        }
        else if (k == 'industries') {
          if (obj[k] && obj[k].length) {
            obj[k].forEach(dataId => {
              if (this.masters.industriesMaster && this.masters.industriesMaster.length) {
                let index = this.masters.industriesMaster.findIndex(master => master.id == dataId);
                if (index > -1) {
                  filter_list.push(this.masters.industriesMaster[index].title)
                }
              }
              else {
                filter_list.push(dataId)
              }

            })
          }
        }
        // else if (k == 'locationId') {
        //   if (obj[k] && this.masters.locationList && this.masters.locationList.length) {
        //     let index = this.masters.locationList.findIndex(master => master.id == obj[k]);
        //     if (index > -1) {
        //       filter_list.push(this.masters.locationList[index].title)
        //     }
        //   }
        // }
        // else if (k == 'jobTypeId') {
        //   if (obj[k] && this.masters.jobTypeList && this.masters.jobTypeList.length) {
        //     let index = this.masters.jobTypeList.findIndex(master => master.id == obj[k]);
        //     if (index > -1) {
        //       filter_list.push(this.masters.jobTypeList[index].title)
        //     }
        //   }
        // }

      })

      return filter_list;
    }
    else {
      return []
    }
  }
  JobsList() {
    if (this.view_type == 3) {
      this.filter_form.controls.expFrom.patchValue(this.value);
      this.filter_form.controls.expTo.patchValue(this.highValue);

      if (this.filter_form.value.locationId) {
        let arrLocation = this.filter_form.value.location;
        if (arrLocation && arrLocation.length) {
          if (arrLocation.indexOf(this.filter_form.value.locationId) < 0) {
            arrLocation.push(this.filter_form.value.locationId);
            this.filter_form.controls.location.patchValue(arrLocation)
          }
        }
        else {
          this.filter_form.controls.location.patchValue([this.filter_form.value.locationId])
        }
      }
      if (this.filter_form.value.jobTypeId) {
        let arrLocation = this.filter_form.value.jobType;
        if (arrLocation && arrLocation.length) {
          if (arrLocation.indexOf(this.filter_form.value.jobTypeId) < 0) {
            arrLocation.push(this.filter_form.value.jobTypeId);
            this.filter_form.controls.jobType.patchValue(arrLocation)
          }
        }
        else {
          this.filter_form.controls.jobType.patchValue([this.filter_form.value.jobTypeId])
        }
      }
      if (this.filter_form.value.industryId) {
        let arrLocation = this.filter_form.value.industries;
        if (arrLocation && arrLocation.length) {
          if (arrLocation.indexOf(this.filter_form.value.industryId) < 0) {
            arrLocation.push(this.filter_form.value.industryId);
            this.filter_form.controls.industries.patchValue(arrLocation)
          }
        }
        else {
          this.filter_form.controls.industries.patchValue([this.filter_form.value.industryId])
        }
      }

    }
    console.log(this.filter_form.value)
    this.jobs_service.saveJobs(this.filter_form.value).subscribe(res => {
      this.job_details_display = true;
      this.applied_filters = this.prepareFilterList(this.filter_form.value)
      if (res['data']) {
        this.total_count = res['data'].count;
        this.fetch_jobs = 1;
        this.jobs = [];
        try {
          let el = document.getElementById('job-explain-content')
          let top = el.offsetTop
          console.log(top)
          window.scrollTo({ top: top, behavior: "smooth" })
          // document.getElementById('job-explain-content').scrollIntoView({ behavior: 'smooth' })
        }
        catch (err) {
          console.log(err)
        }
        if (res['data'].list && res['data'].list.length) {
          res['data'].list.forEach(item => {
            if (!item.keySkillsArr && item.keySkills) {
              item['keySkillsArr'] = item.keySkills.split(',')
            }
          })
          this.jobs = jsonDeepParse(res['data'].list);
          console.log(this.jobs);
          this.profile_settings_srv.setJobList(this.jobs)
          if (this.view_type == 1 || !this.view_type) {
            // this.getJobDetails(this.jobs[0], 1);
          }
        }
      }
      this.page_rendered = true;
    })
    /*  this.jobs_service.getJobs().subscribe((res) => {

       if (res['data']) {
         if (res['data'].masters) {
           this.emp_job_apply = res['data'].masters.emp_job_apply;
           this.refer_a_friend = res['data'].masters.emp_resume_save;
         }
         if (res['data'].list) {
           this.jobs = res['data'].list;
           if (!this.jobs || this.jobs.length) {
             this.jobs_section['innerHTML'] = `<h4 class="card-title text-center m-0">
             No Jobs!
             </h4>`
           }
         }
       }
     }) */
    //this.getcomments(this.job)
    // this.getcomments("code")
  }


  comment_flag = false
  changecommentPage() {
    this.comment_flag = !this.comment_flag;
  }

  text_area: "number"
  getcomments(code) {
    this.text_area = code
    this.jobs_service.getcomments(code).subscribe((res) => {
      //
      if (res['data']) {
        if (res['data'].Table) {
          this.comment = res['data'].Table;
        }
        //
      }
    })
  }
  ngAfterViewInit() {
    if (this.jobs_section && this.jobs_section.nativeElement && this.jobs_section.nativeElement.innerHTML) {
      this.jobs_section.nativeElement.innerHTML = '<img src="/assets/loader.gif">';
    }
  }
  filterData() {
    let obj = this.filter_form.value;
    this.fetch_jobs = 0;
    this.jobs_service.saveJobs(obj).subscribe((res) => {
      //
      this.jobs = [];
      this.fetch_jobs = 1;
      if (res['data']) {
        if (res['data'].list.length) {
          this.jobs = jsonDeepParse(res['data'].list);
        }
      }

      this.jobs = [... this.jobs];
      this.change_detect.detectChanges();

    });
    // this.filter_details = new FilterDetails();
  }
  socialMediaShare(req_id) {
    if (req_id) {
      const dialogRef = this.dialog.open(SocialMediaShareComponent, {
        width: '450px',
        panelClass: "TM-Dialog",

        data: {
          req_id: req_id || 0
        }
      });

      dialogRef.afterClosed().subscribe(() => {

      });
      // window.open("https://www.facebook.com/dialog/share?app_id=2403562973199584&display=page&href=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2F&redirect_uri=https%3A%2F%2Flocalhost%3A4201%2Fhome", '_blank');
      // window.open("https://twitter.com/intent/tweet?text=Hello%20world");
      // window.open('https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&su=Your+Subject+here&body="MSG"&ui=2&tf=1&pli=1');
      // window.open("https://www.linkedin.com/shareArticle?mini=true&url=http://23.236.49.140:1123&title=LinkedIn%20Developer%20Network&summary=My%20favorite%20developer%20program&source=LinkedIn");
    }
  }
  referAFriend(requirement_id) {
    const dialog = this.dialog.open(ResumeReferralDetailsComponent, {
      width: '400px',
      disableClose: true,
      panelClass: "TM-Dialog",

    });
    dialog.afterClosed().subscribe(() => {


    },
      () => {
        //
      });
    (dialog.componentInstance).requisition_id = requirement_id;
  }
  // applyJob(requirement_id, apply_flag) {
  //   let user = this.session_service.getSession();
  //
  //   if ((!user || !user["UserId"])) {
  //     const dialog = this.dialog.open(LoginComponentV2, {
  //       width: '500px',
  //       disableClose: true,
  //     });
  //     dialog.afterClosed().subscribe(result => {
  //
  //     });
  //   }
  //   else if (!apply_flag) {
  //     const dialog = this.dialog.open(ResumeReferralCopyComponent, {
  //       width: '400px',
  //       disableClose: true,
  //     });
  //     dialog.afterClosed().subscribe(result => {
  //
  //       if (result) {
  //         this.JobsList();
  //       }
  //     },
  //       (reason) => {
  //         //
  //       });
  //     (dialog.componentInstance).referrer_id = this.activated_route.snapshot.params.user_id;
  //     (dialog.componentInstance).requirement_id = requirement_id;
  //   }
  // }

  savelike(code, like_flag) {
    if (like_flag == 1) {
      like_flag = 0
    } else if (like_flag == 0) {
      like_flag = 1
    }
    let obj = { req_id: code, like_flag: like_flag };
    this.jobs_service.savelike(obj).subscribe(res => {

      if (res["status"] == true) {
        this.jobs_service.saveJobs(this.filter_details).subscribe(res => {
          if (res['data']) {
            if (res['data'].masters) {
              if (res['data'].list && res['data'].list.length) {
                this.jobs = jsonDeepParse(res['data'].list);

              }
            }
          }
        });
      }
    })

  }

  savebookmark(job, bookmark_flag?) {
    console.log(job)
    let req = {
      productCode: job.productCode,
      markAsFavourite: job.markedAsFavourite ? 0 : 1
    }
    console.log(req)
    this.jobs_service.savebookmark(req).subscribe(res => {
      if (res["status"]) {
        job.markedAsFavourite = !job.markedAsFavourite
        this.notification_srv.success(res['message'], 'Close', 5000)
      }
    })


  }

  savecomment(code) {
    let obj = { req_id: code, comment: this.comment_form.value.comment, status_flag: this.comment_form.value.status_flag };
    this.jobs_service.savecomment(obj).subscribe(res => {

      if (res["status"] == true) {
        this.getcomments(code)
        this.jobs_service.saveJobs(this.filter_details).subscribe(res => {
          if (res['data']) {
            if (res['data'].masters) {
              if (res['data'].list && res['data'].list.length) {
                this.jobs = jsonDeepParse(res['data'].list);
              }
            }
          }
        });
      }
    })
    this.comment_form = this.formBuilder.group({
      comment: '',
      req_id: '',
      status_flag: 1
    })


  }
  closeSidebar() {
    this.sidebar.close();
  }
  // getJobDetails(job, doNotToggle?) {
  //   this.jobs.forEach(jobs => {
  //     jobs.active = false;
  //   })
  //   job.active = true;


  //   if (!doNotToggle) {
  //     if (window.innerWidth <= 992) {
  //       this.sidebar.open();
  //     }
  //   }


  //   this.jobs_service.getJobs({
  //     productCode: job.productCode
  //   }).subscribe((res) => {
  //     this.job_details_display = true;

  //     if (res && res['data']) {
  //       if (res['data']) {
  //         if (res['data'].detail) {
  //           this.job_details = jsonDeepParse(res['data'].detail);
  //           this.job_details['applied'] = job.applied;
  //           if (this.job_details['keySkills'] && this.job_details['keySkills'] != '') {
  //             try {
  //               this.job_details['keySkillsList'] = this.job_details['keySkills'].split(',')

  //             }
  //             catch (err) {
  //               console.log(err)
  //             }
  //           }
  //         }
  //         if (res['data'].relevant_jobs && res['data'].relevant_jobs.length) {
  //           this.relevant_jobs = res['data'].relevant_jobs || [];
  //         }
  //       }
  //     }
  //   })
  // }
  getNextBatch(e) {
    //
    let total = this.viewport.getDataLength();
    let end = this.viewport.getRenderedRange().end;
    console.log(total)
    console.log(end)
    if (end == total && this.total_count > this.jobs.length && !this.enable_lock) {
      this.enable_lock = 1;
      let obj = this.filter_form.value;
      obj['startPage'] = Math.ceil(this.jobs.length / this.filter_form.value.limit) + 1;
      this.jobs_service.saveJobs(obj).subscribe(res => {
        if (res && res['data'] && res['data'].list) {
          res['data'].list = jsonDeepParse(res['data'].list);
          this.jobs = [...this.jobs, ...res['data'].list];
          this.total_count = res['data'].count;
          this.profile_settings_srv.setJobList(this.jobs);
          setTimeout(() => {
            this.enable_lock = 0;
          })
        }

      });
    }
  }

  getNextPage(ev, limit_obj) {
    console.log(ev);
    console.log(limit_obj);
    if (limit_obj) {
      console.log(limit_obj)
      this.limit = limit_obj.code;
      this.start_page = 1;
      this.filter_form.controls.startPage.patchValue(1);
      this.filter_form.controls.limit.patchValue(this.limit);
    }
    if (ev) {
      console.log(ev)
      this.start_page = ev;
      this.filter_form.controls.startPage.patchValue(this.start_page);
    }

    this.JobsList()
  }

  sortByChanges(type) {
    this.filter_form.controls.sortBy.patchValue(type);
    this.JobsList();
  }
  checkBoxEvent(ev, id) {
    console.log(document.getElementById(id))
    let el: any = document.getElementById(id)
    console.log(el.checked)


    console.log(id)
  }
  valueChanges(ev) {
    this.filter_form.controls.startPage.patchValue(1)
    if (this.page_rendered) {
      this.JobsList();
    }
  }

  getExperienceTitle(job: any): string {
    if (job.expTo > 0) {
      const yearText = job.expTo > 1 ? 'years' : 'years';
      return `${job.expFrom} - ${job.expTo} ${yearText}`;
    } else if (job.expTo == 0) {
      return 'Fresher';
    } else {
      return 'Fresher';
    }
  }

  getNoticePeriodTitle(job: any): string {
    if (job.noticePeriodTo > 0) {
      const dayText = job.noticePeriodTo > 1 ? 'days' : 'day';
      return `${job.noticePeriodFrom} - ${job.noticePeriodTo} ${dayText}`;
    } else if (job.noticePeriodTo == 0) {
      return 'Immediate';
    } else {
      return 'Immediate';
    }
  }

  getLocationTitle(job: any): string {
    return job.jobLocation != "" ? job.jobLocation : 'Not Mentioned';
  }

  getJobTypeTitle(job: any): string {
    return job.jobType != "" ? job.jobType : 'Not Mentioned';
  }

  getCompensationTitle(job: any): string {
    if (job.expSalaryTo > 0 || job.expSalaryFrom > 0) {
      const symbol = job.expSalaryCurrSymbol || '';
      const from = job.expSalaryFrom || 0;
      const to = job.expSalaryTo || 0;
      const duration = job.expSalaryScaleDuration || '';
      
      if (to > 0) {
        return `${symbol}${from} - ${to} ${duration}`;
      } else {
        return `${symbol}${from} ${duration}`;
      }
    } else {
      return 'Not Mentioned';
    }
  }

  getSkillsTitle(job: any): string {
    return job.keySkills || 'Not Mentioned';
  }

}
export class JobMaster {
  skills = [];
  location = [];
  department = [];
  designation = [];

}
